import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  const changeLanguage = (lang: string) => {
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
    setIsOpen(false);
    window.location.reload();
  };

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative inline-block" ref={menuRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className=" xs:w-4 xs:h-4 sm:w-6 sm:h-6 rounded-full overflow-hidden"
      >
        <img
          src={i18n.language === 'ar' ? "/asset/Libya-Flag-5.jpg" : "/asset/britch flag.jpg"}
          alt="flag"
          className="w-full h-full object-cover"
        />
      </button>

      {isOpen && (
        <div className="absolute w-28 text-black mt-2 bg-white border rounded shadow-md z-10 right-0">
          <div
            onClick={() => changeLanguage('en')}
            className="p-2 cursor-pointer border-b hover:bg-gray-100 flex items-center gap-2"
          >
            <img src="/asset/britch flag.jpg" alt="English" className="w-8 h-5 object-cover" />
            English
          </div>
          <div
            onClick={() => changeLanguage('ar')}
            className="p-2 cursor-pointer hover:bg-gray-100 flex items-center gap-2"
          >
            <img src="/asset/Libya-Flag-5.jpg" alt="العربية" className="w-8 h-5 object-cover" />
            العربية
          </div>
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
